import { useEffect } from 'react';

/**
 * Warms the browser cache for a video the next page will need by appending
 * a `<link rel="preload" as="video">` tag to <head>. De-dupes per URL so
 * additional mounts won't trigger duplicate fetches.
 */
const usePreloadVideo = (href: string): void => {
  useEffect(() => {
    if (!href) return;

    const selector = `link[rel="preload"][as="video"][href="${CSS.escape(href)}"]`;
    if (document.head.querySelector(selector)) return;

    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'video';
    link.href = href;
    document.head.appendChild(link);

    return () => {
      link.remove();
    };
  }, [href]);
};

export default usePreloadVideo;
